export default "__VITE_ASSET__DzvcUp0z__"